import React from 'react'
import { StaticImage as Img } from 'gatsby-plugin-image';
import Content from './style'
import { Link, SuperTag } from '~components';
import { Col, Container, Row } from 'react-bootstrap';


export default function ContentSectionTwo(){

return(
<Content backgrounColor="#fff">
  <Content.ContentShape>
    <Img src="../../../assets/image/project-management/l2-content-2-shape.png" alt="content" layout="constrained" placeholder="blurred"/>
  </Content.ContentShape>
  <Container>
    <Content.Block>
    <Row className="align-items-center justify-content-center justify-content-lg-start">
    <Col className="col-xl-7 col-lg-6 col-md-8 col-xs-10">
        <Content.Image>
            <Img src="../../../assets/image/project-management/l2-content-img-21.png" alt="content" layout="fullWidth" placeholder="blurred"/>
          <Content.ContentShape>
            <Img src="../../../assets/image/project-management/l2-content-2-shape-2.png" alt="content" layout="fullWidth" placeholder="blurred"/>
          </Content.ContentShape>
        </Content.Image>
      </Col>
      <Col xs="12" className="col-xl-5 col-lg-6 col-md-8 col-xs-10">
        <Content.Box>
          <Content.Title as="h2"> <SuperTag value="Colloborate with clients and teams with ease."/> </Content.Title>

          <Content.Text> <SuperTag value="Send, sign, store, edit and share documents to teams and clients in a secure way with a peace of mind."/> </Content.Text>
          <Content.Button to="/early-access">Get Started Now
          </Content.Button>
        </Content.Box>
      </Col>
    </Row>
    </Content.Block>
  </Container>
</Content>
)
}